import axios from 'axios';

export default class PremiumRepository {
    static create(type) {
        return new Promise((resolve) => {
            axios.post('/premium/' + type).then(() => resolve());
        });
    }
}
